<template>
  <header>
    <div class="main">
      <h1>
        <router-link to="/" class="logo">
          <img src="@/assets/images/logo.png" alt="UnionWallex">
        </router-link>
      </h1>

      <div class="right">
        <nav>
          <ul class="nav">
            <li class="dropdown-wrapper"
                @mouseenter="showSolutionsDropdown = true"
                @mouseleave="showSolutionsDropdown = false">
              <a href="#" class="nav-link">
                <span>{{ $t('nav.solutions') }}</span>
              </a>

              <transition name="slide-fade">
                <div v-show="showSolutionsDropdown"
                     class="solutions-dropdown"
                     @mouseenter="showSolutionsDropdown = true"
                     @mouseleave="showSolutionsDropdown = false">
                  <div v-for="(item, index) in solutionsOptions"
                       :key="index"
                       class="dropdown-item"
                       :class="{ 'hover-active': activeIndex === index }"
                       @mouseenter="activeIndex = index"
                       @mouseleave="activeIndex = -1">
                    <router-link :to="item.route">{{ item.label }}</router-link>
                  </div>
                </div>
              </transition>
            </li>
            <li class="dropdown-wrapper"
                @mouseenter="showResourceDropdown = true"
                @mouseleave="showResourceDropdown = false">
              <a href="#" class="nav-link">
                <span>{{ $t('nav.resources') }}</span>
              </a>

              <transition name="slide-fade">
                <div v-show="showResourceDropdown"
                     class="solutions-dropdown"
                     @mouseenter="showResourceDropdown = true"
                     @mouseleave="showResourceDropdown = false">
                  <div v-for="(item, index) in resourcesOptions"
                       :key="index"
                       class="dropdown-item"
                       :class="{ 'hover-active': activeIndex === index }"
                       @mouseenter="activeIndex = index"
                       @mouseleave="activeIndex = -1">
                    <router-link :to="item.route">{{ item.label }}</router-link>
                  </div>
                </div>
              </transition>
            </li>
            <li class="dropdown-wrapper"
                @mouseenter="showAboutDropdown = true"
                @mouseleave="showAboutDropdown = false">
              <a href="#" class="nav-link">
                <span>{{ $t('nav.about') }}</span>
              </a>

              <transition name="slide-fade">
                <div v-show="showAboutDropdown"
                     class="solutions-dropdown"
                     @mouseenter="showAboutDropdown = true"
                     @mouseleave="showAboutDropdown = false">
                  <div v-for="(item, index) in AboutOptions"
                       :key="index"
                       class="dropdown-item"
                       :class="{ 'hover-active': activeIndex === index }"
                       @mouseenter="activeIndex = index"
                       @mouseleave="activeIndex = -1">
                    <router-link :to="item.route">{{ item.label }}</router-link>
                  </div>
                </div>
              </transition>
            </li>

            <li>
              <router-link to="/help/center">
                <span>{{ $t('nav.help') }}</span>
              </router-link>
            </li>
          </ul>
        </nav>

        <!-- 登录和注册按钮 -->
        <el-button class="btn register" type="primary" @click="openLoginDialog" >{{ $t('button.login') }}</el-button>
        <el-button class="btn register" @click="openRegisterDialog">{{ $t('button.register') }}</el-button>

        <div class="menu_btn" @click="toggleMobileMenu">
          <div class="line"></div>
        </div>
      </div>

      <!-- 语言选择区域 -->
      <div class="lang_sel" @click="toggleLanguageDropdown">
        <span>{{ currentLanguageLabel }}</span>
        <div class="icon down">
          <img src="@/assets/images/down_sel.png" alt="Dropdown">
        </div>

        <!-- 下拉菜单 -->
        <div v-show="showLanguageDropdown" class="lang-dropdown">
          <div
              v-for="lang in supportedLanguages"
              :key="lang.value"
              @click.stop="switchLanguage(lang.value)"
              class="lang-option"
          >
            {{ lang.label }}
          </div>
        </div>
      </div>
    </div>

    <!-- 登录对话框 -->
    <el-dialog v-model="loginDialogVisible" :title="$t('login.title')" width="450px" class="login-dialog">
      <LoginPage @close="closeLoginDialog" />
    </el-dialog>
    <!-- 注册对话框 -->
    <el-dialog v-model="registerDialogVisible" :title="$t('register.title')" width="450px"  class="login-dialog">
      <Register @close="closeRegisterDialog" />
    </el-dialog>
  </header>
</template>

<script>
import LoginPage from '@/components/LoginPage.vue';
import Register from '@/components/RegisterPage.vue';

export default {
  components: {
    LoginPage,
    Register,
  },
  data() {
    return {
      showLanguageDropdown: false,
      supportedLanguages: [
        { value: 'zh', label: '简体中文' },
        { value: 'en', label: 'English' },
        { value: 'br', label: 'Português' }
      ],
      isMobileMenuOpen: false,
      showSolutionsDropdown: false,
      showResourceDropdown: false,
      showAboutDropdown: false,
      activeIndex: -1,
      loginDialogVisible: false, // 控制登录对话框显示
      registerDialogVisible: false, // 控制注册对话框显示
    };
  },
  computed: {
    currentLanguageLabel() {
      return this.supportedLanguages.find((l) => l.value === this.$i18n.locale).label;
    },
    solutionsOptions() {
      return [
        {
          label: this.$t('footer.solutions_acquiring'),
          route: '/solutions/global-collection',
        },
        {
          label: this.$t('footer.solutions_payments'),
          route: '/solutions/payments',
        },
        {
          label: this.$t('footer.solutions_platform'),
          route: '/solutions/platform',
        },
        {
          label: this.$t('footer.solutions_access'),
          route: '/solutions/access',
        },
      ];
    },
    resourcesOptions() {
      return [
        {
          label: this.$t('footer.resources_deposit'),
          route: '/resource/AcquisitionDoc',
        },
        {
          label: this.$t('footer.resources_withdraw'),
          route: '/resource/PaymentDoc',
        },
        {
          label: this.$t('footer.resources_subscription'),
          route: '/resource/SubscriptionDoc',
        },
      ];
    },
    AboutOptions() {
      return [
        {
          label: this.$t('footer.aboutUs_company'),
          route: '/about/aboutus',
        },
        {
          label: this.$t('footer.aboutUs_terms'),
          route: '/about/policy',
        },
        {
          label: this.$t('footer.aboutUs_join'),
          route: '/about/contactus',
        },
      ];
    },
  },
  methods: {
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    switchLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.showLanguageDropdown = false;
    },
    // 打开登录对话框
    openLoginDialog() {
      this.$router.push('/login')
    },
    // 关闭登录对话框
    // closeLoginDialog() {
    //   this.loginDialogVisible = false;
    // },
    // 打开注册对话框
    openRegisterDialog() {
      this.$router.push('/about/contactus')
    },
    // // 关闭注册对话框
    // closeRegisterDialog() {
    //   this.registerDialogVisible = false;
    // },
  },
};
</script>


<style scoped>
.login-dialog {
  border-radius: 8px;
}
:deep(.el-dialog__header) {
  background: #409EFF;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 16px;
}

:deep(.el-dialog__title) {
  color: white;
  font-size: 18px;
}

/* 新增样式 */
.dropdown-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.solutions-dropdown {
  top: calc(100% + 5px); /* 增加间隔避免快速移动时闪退 */
  left: -10px; /* 对齐文字基线 */
  min-width: 180px; /* 加宽适应长文本 */
  width: auto;
}

.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
/* 下拉菜单样式（结合网页5的交互逻辑） */
.solutions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: #1A2B4D;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  border-radius: 4px;
  min-width: 150px;
  z-index: 100;
}

.dropdown-item {
  padding: 12px 16px;
  color: rgba(255,255,255,0.9);
  transition: all 0.2s;
  white-space: nowrap;

  /* 悬停高亮效果（参考网页3） */
  &:hover {
    background: rgba(255,255,255,0.1);
    transform: translateX(6px);
  }
}

.hover-active {
  border-left: 3px solid #409EFF; /* 动态高亮指示条 */
}



.lang_sel {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 4px;
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.3);
  color: white;
  transition: all 0.2s ease;
  font-size: 14px; /* 与导航栏其他文字尺寸统一 */

  &:hover {
    background: rgba(255,255,255,0.2);
    border-color: rgba(255,255,255,0.5);
  }

  &::after {
    content: "";
    margin-left: 8px;
    font-size: 12px;
    color: #FFD700;
  }
}

.lang-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #1A2B4D; /* 适配导航栏深蓝背景 */
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  border-radius: 4px;
  min-width: 120px; /* 缩小宽度 */
  overflow: hidden;
  z-index: 100;
}

.lang-option {
  padding: 10px 16px;
  color: rgba(255,255,255,0.9);
  font-size: 14px;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background: rgba(255,255,255,0.1);
  }

  &::before {
    content: attr(data-code);
    color: #FFD700;
    margin-right: 8px;
    font-weight: 500;
  }
}
</style>
